import React, { useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IconCheck, IconBuilding } from "@tabler/icons-react";

// Schema de validação
const departmentSchema = yup.object().shape({
  name: yup
    .string()
    .required("Nome é obrigatório")
    .max(100, "Nome deve ter no máximo 100 caracteres"),
  description: yup.string(),
  is_active: yup.boolean().default(true),
});

const DepartmentModal = ({
  show,
  onHide,
  onSave,
  department,
  isEdit,
  loading,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(departmentSchema),
    defaultValues: {
      name: "",
      description: "",
      is_active: true,
    },
  });

  const watchedIsActive = watch("is_active");

  useEffect(() => {
    if (show) {
      if (isEdit && department) {
        reset({
          name: department.name || "",
          description: department.description || "",
          is_active: department.is_active !== false,
        });
      } else {
        reset({
          name: "",
          description: "",
          is_active: true,
        });
      }
    }
  }, [show, isEdit, department, reset]);

  const handleFormSubmit = (data) => {
    onSave(data);
  };

  const handleClose = () => {
    reset();
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <IconBuilding size={20} className="me-2" />
            {isEdit ? "Editar Departamento" : "Novo Departamento"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  Nome <span style={{ color: "#dc3545" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ex: Comercial, Suporte, Financeiro..."
                  {...register("name")}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Descrição (opcional)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Descrição do departamento..."
                  {...register("description")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col xs={12}>
              <Form.Group>
                <Form.Check
                  type="switch"
                  id="is_active"
                  label="Departamento ativo"
                  checked={watchedIsActive}
                  onChange={(e) => setValue("is_active", e.target.checked)}
                />
                <Form.Text className="text-muted">
                  Desative para ocultar temporariamente este departamento.
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <Spinner animation="border" size="sm" className="me-1" />
            ) : (
              <IconCheck size={16} className="me-1" />
            )}
            {isEdit ? "Atualizar" : "Criar"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default DepartmentModal;
